export const Technology = ({ data=[], capabilities=[] }) => (
<section id="technology" className="section section--technology-v7" aria-labelledby="technology-title">
 <div className="site-container">
  <div className="tech-head-v7" data-motion><p className="eyebrow">TECHNOLOGY & EXPERIENCE</p><h2 id="technology-title">스택을 나열하는 대신<br/><span>연결되는 구조를 보여줍니다.</span></h2></div>
  <div className="tech-flow-v7">
   <div className="tech-line-v7" aria-hidden="true"><i/></div>
   {data.map((item,i)=><article className="tech-node-v7" key={item.category} data-motion><span>0{i+1}</span><div><p>{item.description}</p><h3>{item.category}</h3></div><div className="tech-pills-v7">{item.items.map(v=><b key={v}>{v}</b>)}</div></article>)}
  </div>
  <div className="build-v7" data-motion><div><p className="eyebrow eyebrow-on-dark">WHAT I CAN BUILD</p><h3>기술 이름보다<br/><span>구현 가능한 범위로.</span></h3></div><div>{capabilities.map((c,i)=><p key={c}><i>{String(i+1).padStart(2,'0')}</i><strong>{c}</strong></p>)}</div></div>
 </div>
</section>);
